"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../material/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _error_template_styles = _interopRequireDefault(require("./error_template_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// styles

/* ========== ~~~~~~~~~~ EXPORT : ERROR : TEMPALTE ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_error_template_styles.default)(function (props) {
  return _react.default.createElement(_index.Page, {
    name: "errortemplate",
    klass: props.classes.errortemplate
  }, _react.default.createElement(_index.Content, null, _react.default.createElement(_index.Group, {
    name: "message"
  }, _react.default.createElement(_index.Link, {
    type: "internal",
    name: "insticator",
    action: "dashboard/home",
    title: "Return to Home Page"
  }, _react.default.createElement(_index.Logo, {
    name: "insticator",
    text: "Insticator"
  })), _react.default.createElement("div", {
    className: "code"
  }, props.code), _react.default.createElement(_index.Title, null, props.title), _react.default.createElement(_index.BodyCopy, null, props.bodycopy), props.button), _react.default.createElement(_index.Group, {
    name: "visual"
  }, props.illustration)));
});

exports.default = _default;